/** A clock-change error requires corrected source times, not another read. */
export type AvailabilityQueryState = { state: { error: unknown; isInvalidated?: boolean } };

export function availabilityTimeErrorMessage(error: unknown): string | null {
  if (typeof error !== 'object' || error === null) return null;
  const { code, message } = error as { code?: unknown; message?: unknown };
  if (code !== '22023' || typeof message !== 'string') return null;
  if (message === 'inventory_location_wall_time_ambiguous') {
    return 'Availability needs a time review: a local time occurs twice when the clocks change. Open the event Schedule and correct the affected time before checking again.';
  }
  if (message === 'inventory_location_wall_time_nonexistent') {
    return 'Availability needs a time review: a local time does not exist when the clocks change. Open the event Schedule and correct the affected time before checking again.';
  }
  return null;
}
